/**
 * AreaNavi service.
 */
app.factory("AreaNaviService",
	function() {

		/**
		 * Initial visiblity
		 *
		 * @type {boolean}
		 */
		this.visible = true;

		/**
		 * Set data
		 *
		 * @param countyName
		 * @param urlCounty
		 * @param agencyLink
		 * @param livingLink
		 * @param active
		 */
		this.setData = function(countyName, urlCounty, agencyLink, livingLink, pricesLink, active)
		{
			// Data
			this.countyName = countyName;
			this.urlCounty = urlCounty;
			this.agencyLink = agencyLink;
			this.active = active;
			// Titles
			this.sellName = 'Myytävät asunnot ' + countyName;
			this.rentalName = 'Vuokra-asunnot ' + countyName;
			this.pricesName = 'Asuntojen hinnat ' + countyName;
			this.multiName = 'Kiinteistönvälitys ' + countyName;
			this.livingName = countyName + ' asuinalueena';
			// Links
			this.sellUrl = '/myytavat_asunnot/' + urlCounty;
			this.rentalUrl = '/vuokrattavat_asunnot/' + urlCounty;
			this.pricesUrl = pricesLink;
			this.multiUrl = agencyLink;
			this.livingUrl = livingLink;
		};

		/**
		 * Set navi visible/hidden?
		 *
		 * @param bool
		 */
		this.setVisible = function(bool)
		{
			this.visible = bool;
		};

		return this;
	}
);